/* eslint-disable no-plusplus */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-continue */

function normalizeElement(rawElem) {
  if (!rawElem || typeof rawElem !== 'string') return '';
  return rawElem[0].toUpperCase() + (rawElem.length > 1 ? rawElem.slice(1).toLowerCase() : '');
}

function buildHillFormula(elementCounts) {
  if (!elementCounts || typeof elementCounts !== 'object') return '';

  const counts = { ...elementCounts };
  const parts = [];

  const addElement = (symbol) => {
    const count = counts[symbol];
    if (count) {
      parts.push(symbol + (count > 1 ? count : ''));
      delete counts[symbol];
    }
  };

  addElement('C');
  addElement('H');

  Object.keys(counts)
    .sort()
    .forEach((el) => {
      parts.push(el + (counts[el] > 1 ? counts[el] : ''));
    });

  return parts.join('');
}

// ── V3000 ──────────────────────────────────────────────────────────────────
function countElementsV3000(lines) {
  const elementCounts = Object.create(null);
  const atomLineRe = /^M\s+V30\s+\d+\s+([A-Za-z][a-z]?)\b/;
  let inAtomBlock = false;

  for (const rawLine of lines) {
    const line = rawLine.trim();

    if (!inAtomBlock) {
      inAtomBlock = /^M\s+V30\s+BEGIN\s+ATOM/i.test(line);
      continue;
    }

    if (/^M\s+V30\s+END\s+ATOM/i.test(line)) {
      break;
    }

    const m = atomLineRe.exec(line);
    if (m) {
      const elem = normalizeElement(m[1]);
      if (elem) elementCounts[elem] = (elementCounts[elem] || 0) + 1;
    }
  }

  return elementCounts;
}

// ── V2000 ──────────────────────────────────────────────────────────────────
// V2000 format:
//   Line 4 (index 3): counts line — first 3 chars = atom count, next 3 = bond count, ends with "V2000"
//   Atom block starts at line 5 (index 4), each atom line has element symbol at columns 31–34
function isValidElement(elem) {
  const pseudoAtoms = new Set(['R', 'X', 'A', 'Q']);
  return elem && /^[A-Z][a-z]?$/.test(elem) && !pseudoAtoms.has(elem);
}

function countElementsV2000(lines) {
  const elementCounts = Object.create(null);

  // Counts line is index 3; atom count is the first integer on that line
  const countsLine = lines[3] || '';
  const countsMatch = countsLine.match(/^\s*(\d+)\s+(\d+)/);
  if (!countsMatch) return elementCounts;

  const atomCount = parseInt(countsMatch[1], 10);
  if (!Number.isFinite(atomCount) || atomCount <= 0) return elementCounts;

  // Atom block starts at line index 4
  for (let i = 4; i < 4 + atomCount; i++) {
    const line = lines[i];
    if (!line) break;

    // Element symbol occupies columns 31–34 (0-indexed) in the fixed-width format
    // but we use a regex that matches the symbol after the 3 coordinate fields
    const m = line.match(/^\s*[-\d.]+\s+[-\d.]+\s+[-\d.]+\s+([A-Za-z][a-z]?)\b/);
    if (m) {
      const elem = normalizeElement(m[1]);
      if (isValidElement(elem)) {
        elementCounts[elem] = (elementCounts[elem] || 0) + 1;
      }
    }
  }

  return elementCounts;
}

// ── Public API ─────────────────────────────────────────────────────────────
function parseV3000SumFormula(molfile) {
  if (!molfile || typeof molfile !== 'string' || !molfile.trim()) return '';

  const lines = molfile.split(/\r?\n/);

  // Detect version from the counts line (line index 3) or anywhere in the file
  const isV3000 = lines.some((l) => /V3000/i.test(l));
  const isV2000 = !isV3000 && lines.some((l) => /V2000/i.test(l));

  let elementCounts;
  if (isV3000) {
    elementCounts = countElementsV3000(lines);
  } else if (isV2000) {
    elementCounts = countElementsV2000(lines);
  } else {
    // Unknown / unsupported format — attempt V3000 parse as fallback
    elementCounts = countElementsV3000(lines);
  }

  return buildHillFormula(elementCounts);
}

export default parseV3000SumFormula;
